<template>
  <stock :searchObj="searchObj" :stockTypeObj="stockTypeObj" ref="stock" @postListData="postListData" @toBudgetData="toBudgetData">
    <template v-slot:searchDiv>
      <div class="secondSearchLine">
        <el-date-picker style="width: 3rem" key="hotel" class="dateBox" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" 
          size="mini" v-model="searchObj.date"
          type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" :clearable="false"></el-date-picker>
        <el-autocomplete style="width: 1.5rem;margin:0 0.1rem" v-model="searchObj.startAddress" :fetch-suggestions="querySearchAsync" 
          size="mini" @select="handleSelect($event,'start')">
          <template slot-scope="{ item }">
            <div class="name">{{item.Name_Ru}}</div>
          </template>
        </el-autocomplete>
        <el-autocomplete style="width: 1.5rem;" v-model="searchObj.endAddress" :fetch-suggestions="querySearchAsync" size="mini"
          @select="handleSelect($event,'end')">
          <template slot-scope="{ item }">
            <div class="name">{{item.Name_Ru}}</div>
          </template>
        </el-autocomplete>
      </div>
    </template>
    <template v-slot:contentDiv>
      <div v-for="(item,index) in dataList" :key="index">
        <div v-if="item.productType==2">
          <exclusive-stock :keyStr="keyStr" :productObj="item"></exclusive-stock>
        </div>
        <div v-else-if="item.productType==6" class="contentDiv">
          <hotel-resource-left :productObj="item" :showTag="false" :rightShowStyle="2"
              :btnName="'门店直采特价'" class="contentHead" :budget="budget" 
              @resourceInfo="resourceInfo(item,index)"></hotel-resource-left>
        </div>
        <custom v-else :item="item" :chenckBudgteObj="$refs.stock.budget" :keyStr="keyStr" class="contentDiv"></custom>
      </div>
    </template>
  </stock>
</template>

<script>
import Stock from './stock.vue'
import hotelResourceLeft from './child/hotelResourceLeft.vue'
import Api from '@/components/Api/index.js'
import Custom from './custom.vue'
export default {
  components:{Stock,hotelResourceLeft,Custom},
  data(){
    return{
      searchObj:{
        cityId:null,
        cityName:null,
        cityNameCn:null,
        cityNameEn:null,
        countryId:null,
        date:[],
        star:null,
        location:null,
        searchHotelPrice:null,
        keyword:null,
        productType:0,
        startAddress:'',
        endAddress:'',
        startAddressObj:null,
        endAddressObj:null,
        state:3,
      },
      dataList:[],
      keyStr:'',
      climbSelf : false,
      climbKey:'',
      budget:{},
    }
  },
  props:{
    stockTypeObj:{
      type:Object,
      default:()=>{return {}}
    },
    checkState:{
      type:Number,
      default:0,
    }
  },
  methods:{
    querySearchAsync(queryString, cb) {
      new Api('resource').carQueryStore(queryString).then(res => {
        if (res.status == 200) {
          cb(res.data);
        }
      })
    },
    toBudgetData(budget){
      this.budget = budget
    },
    handleSelect(item,propName) {      
      this.searchObj[propName+'Address'] = item.Name_Ru
      this.searchObj[propName+'AddressObj'] = item
      if(propName=='start'){
        this.searchObj.endAddress= item.Name_Ru
        this.searchObj.endAddressObj = item
      }
    },
    climbStockList(){
      if(!this.$refs.stock.loading&&this.searchObj.productType==0||this.searchObj.productType==3){
        this.$refs.stock.loading = true 
        if(this.searchObj.startAddressObj){
          new Api('resource').sixtCarList({
            pickUpTheCar:this.searchObj.startAddressObj,
            returnPoint:this.searchObj.endAddressObj,
            pickupDate:this.searchObj.date[0].split(" ")[0],
            pickupTime:this.searchObj.date[0].split(" ")[1],
            returnDate:this.searchObj.date[1].split(" ")[0],
            returnTime:this.searchObj.date[1].split(" ")[1]
          }).then(res => {
            this.$refs.stock.loading = false
            if (res.status == 200) {
              if(res.data.length==0) this.climbSelf = true;
              if(this.$refs.stock.mySelf&&this.climbSelf) this.$refs.stock.isMore = true
              res.data.forEach(element => {
                this.$set(element,'isOpen',false)
              });
              res.data.forEach(element => {
                this.dataList.push(element)
              });
              this.climbKey = res.key
            }else{
              this.$message({type:"error",message:res.statusText})
            }
          }).catch(er=>{
            this.$refs.stock.loading = false
          })
        }else{
          new Api('resource').carQueryStore(this.searchObj.cityNameCn).then(res => {
            this.$refs.stock.loading = false
            if (res.status == 200&&res.data.length>0) {
              this.searchObj.endAddress= res.data[0].Name_Ru
              this.searchObj.endAddressObj = res.data[0]
              this.searchObj.startAddress= res.data[0].Name_Ru
              this.searchObj.startAddressObj = res.data[0]
              this.climbStockList()
            }
          })
        }  
      }
    },
    postListData(type){
      if(this.checkState===3){
        if(type=='empty'){
          this.dataList =[]
          this.keyStr=''
          this.climbStockList()
        }
        this.searchObj.startDate = this.searchObj.date[0].split(" ")[0];
        this.searchObj.endDate = this.searchObj.date[0].split(" ")[0];
        this.searchObj.key = this.keyStr;
        if(!this.$refs.stock.isMore){
          new Api('resource').rightStockList({page:this.$refs.stock.page,size:10,q:this.searchObj}).then(res => {
            if (res.status == 200) {
              if(res.data.length<10) this.$refs.stock.isMore = true;
              this.$refs.stock.getDateList(res.data)
              res.data.forEach(element => {
                this.dataList.push(element)
              });
              this.keyStr = res.key
            }else{
              this.$message({type:"error",message:res.statusText})
            }
          })
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.secondSearchLine{
  /deep/ .el-range-separator{
    transform: translateX(-4px);
  }
  .date{
    margin-left: 0.1rem;
  }
  /deep/ .el-select{
    margin-left: 0.1rem;
    width: 1rem;
  }
}
.contentDiv{
  border-radius: 12px 12px 0 0;
  border: 1px solid #db4e1a;
  padding-top: 0.1rem;
  margin-bottom: 0.07rem;
  .contentHead{
    display: flex;
    justify-content: space-between;
    border-bottom: 3px solid #db4e1a;
    .head_left{    
      /deep/ .showCard-imgBox{
        margin-left: 0;
        img{
          margin: 0 0.05rem;
        }
      }
    }
    .head_right{
      .cardContainer{
        background: #f1f4f4;
        width: 1.3rem;
      }
      .cardContainer-oneBox{
        padding: 0.05rem 0.1rem 0.05rem 0.05rem;
        .btn{
          cursor: pointer;
          display: inline-block;
          background: #5677fc;
          color: #fff;
          padding: 0.03rem 0.15rem;
          font-size: 0.12rem;
        }
        .cardContainer-twoBox{
          margin-top: 0.1rem;
          .circle{
            i{
              font-size: 0.2rem;
              color: #333;
            }
          }
          .fractionBox{
            >b{
              color: #d81b43;
              font-size: 0.16rem;
              margin:0 0.05rem;
            }
            >span{
              font-weight: bold;
              color: #676976;
              font-size: 0.12rem;
            }
          }
        }
      }
      .showCard-tag{
        padding: 0 0.04rem;
        height: 0.35rem;
        background: #db4e1a;
        display: flex;
        align-items: center;
        margin-top: 0.05rem;
        justify-content: space-between;
        cursor: pointer;
        color: #fff; 
        >div{
          >i{
            font-size: 0.25rem;
          }
          >b{
            font-size: 0.18rem;
          }
          >label{      
            font-size: 0.12rem;
            padding-right: 3px;
          }
        }
      }
    }
  }
  .contentContainer{
    .boxContainer1{
      font-size: 0.12rem;
      margin-top: 0.1rem;
      margin-left: 0.1rem;    
      .firstLine{
        font-weight: bold;
        display: flex;
        align-items: center;
      }
      .productName{
        font-size: 0.125rem;
        width: 1.4rem;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .item1{
        margin-left: 0.1rem;
        display: flex;
        align-items: center;
        .item2{
          margin-left: 0.2rem;
          display: flex;
          align-items: center;
          >span{
            color: #ff0000;
            font-size: 0.16rem;
            text-decoration: underline;
            width: 1rem;
          }
        }
        .tagBox{
          margin-left: 0.4rem;
          >span{
            font-size: 0.14rem;
            font-weight: normal;
          }
        }
      }
      .item3{
        margin-left: 0.3rem;
        display: flex;
        .qiang{
          font-size: 0.18rem;
          box-shadow: 0px 0px 4px 0px #333;
          border-radius: 50%;
          color: red;
          text-align: center;
          display: inline-block;
          width: 0.26rem;
          height: 0.26rem;
          margin: 1px;
          vertical-align: middle;
          margin-right: 0.05rem;
        }
        >i{
          font-size: 0.28rem;
        }
      }
      .box2{
        display: flex;
        margin-top: 0.1rem;
        .item1{
          >span:first-child{
            color: #db4e1a;
            font-weight: bold;
            margin-left: 1.4rem;
            width: 0.6rem;
          }
          >span:last-child{
            margin-left: 0.1rem;
            width: 3.55rem;
          }
        }
        .item2{
          cursor: pointer;
          margin-left: 0.3rem;
          color: #db4e1a;
        }
      }
    }
    >p{
      >i{
        font-size: 0.25rem;
      }
    } 
  }
}
</style>